import { IRole } from './../../models/role';
import { Injectable, OnInit } from '@angular/core';
import { DataService } from '../data-services/data.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends DataService<IRole> implements OnInit{
 
  protected collectionname = 'role';
  protected _relativeUrl = 'role';

  ngOnInit(): void { 
    this.collectionname = 'role';
  }

}
